
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEnhancedAuthContext } from '@/context/auth/EnhancedAuthContext';
import { Loader } from "@/components/ui/loader";
import { Compass } from 'lucide-react';

const Dashboard = () => {
  const { user, hasRole } = useEnhancedAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      // Smart routing based on user role
      if (user.is_superuser || hasRole(['admin'])) {
        navigate('/app/dashboard', { replace: true });
      } else {
        navigate('/app/home', { replace: true });
      }
    }
  }, [user, navigate, hasRole]);

  // Show loading while determining redirect
  return (
    <div className="container mx-auto py-6">
      <div className="mb-6 flex items-center gap-2">
        <Compass className="h-5 w-5 text-muted-foreground" />
        <p className="text-muted-foreground">Redirecting you to your dashboard...</p>
      </div>
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader size={32} text="Loading..." />
      </div>
    </div>
  );
};

export default Dashboard;
